export default __webpack_public_path__ + "static/media/login-bg-39.bec8c8c5.jpg";